import { PermissionsFormPage } from "~/pages/PermissionsFormPage";
import { trpc } from "~/utils/trpc";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useBreadCrumbs } from "~/contexts/useBreadCrumbs";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/permissions/edit/$id")({
  component: RouteComponent,
});

function RouteComponent() {
  const { datasetSlug, id } = Route.useParams();
  useBreadCrumbs([
    { title: "Permissions", link: `/${datasetSlug}/settings/permissions` },
    { title: "Edit", link: `/${datasetSlug}/settings/permissions/edit/${id}` },
  ]);
  const { data: role } = useQuery({
    ...trpc.permissions.getRole.queryOptions({ id }),
    refetchOnMount: true,
    staleTime: 0,
  });

  return <PermissionsFormPage role={role} datasetSlug={datasetSlug} />;
}
